/** Removes special czech diacritical symbols with basic forms of letters
 * @param string String to purify
 */
export function removeDiacritics(string: string) {
  const diacritics = 'ěščřžýáíéóťďňůúĚŠČŘŽÝÁÍÉÓŤĎŇŮÚ';
  const basic = 'escrzyaieotdnuuESCRZYAIEOTDNUU';
  let newString = '';
  for (let s = 0; s < string.length; s++) {
    const replacing = diacritics.indexOf(string[s]);
    newString += replacing >= 0 ? basic[replacing] : string[s];
  }
  return newString;
}

/** Removes special symbols in provided string and replaces spaces with provided divider
 * @param string String to normalize and despacize
 * @param divider String to replace spaces with (default '')
 */
export function linkize(string: string, divider: string = '') {
  return string.normalize('NFKD').replace(/[^\w]/g, divider);
}